module.exports = __webpack_public_path__ + "img/9.99d1e399.jpg";